import { forwardRef } from 'react';

import type { OfferCardProps } from '@wwe-portal/ui/features/offer/type';
import { ResponsiveExclusiveItemColection } from '@wwe-portal/ui/features/club-store';
import { SubscriptionTier } from '@wwe-portal/entities/subscription.type';
import type { ExclusiveItemProps } from '@wwe-portal/ui/features/club-store/exclusive-items/exclusive-item';

import { SectionLayout } from './section-layout';

export interface ExclusiveItemSectionProps {
  exclusiveItems:
    | Record<SubscriptionTier, (ExclusiveItemProps | OfferCardProps)[]>
    | undefined;
  titles: Record<SubscriptionTier, React.ReactNode>;
  descriptions: Record<SubscriptionTier, React.ReactNode>;
  enabled: Record<SubscriptionTier, boolean>;
  isLoading: boolean;
  onClick: (data: {
    tier: SubscriptionTier | undefined;
    offerData: OfferCardProps;
  }) => void;
  onShowOfferCard: (offer: ExclusiveItemProps) => void;
  processingOfferId: string | undefined;
}

export const ExclusiveItemsSection = forwardRef<
  HTMLDivElement,
  ExclusiveItemSectionProps
>(
  (
    {
      isLoading,
      exclusiveItems,
      onClick,
      onShowOfferCard,
      processingOfferId,
      titles,
      descriptions,
      enabled,
    },
    ref
  ) => {
    return (
      <div className="flex flex-col gap-y-6" ref={ref}>
        {[
          SubscriptionTier.GOLD,
          SubscriptionTier.SILVER,
          SubscriptionTier.BRONZE,
        ]
          .filter((tier) => enabled[tier])
          .map((tier) => (
            <SectionLayout
              description={descriptions[tier]}
              key={tier}
              title={titles[tier]}
            >
              {exclusiveItems && (
                <ResponsiveExclusiveItemColection
                  data={exclusiveItems[tier] as ExclusiveItemProps[]}
                  isLoading={isLoading}
                  onClick={onClick}
                  onShowOfferCard={onShowOfferCard}
                  processingOfferId={processingOfferId}
                />
              )}
            </SectionLayout>
          ))}
      </div>
    );
  }
);

ExclusiveItemsSection.displayName = 'ExclusiveItemsSection';
